/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Tab, Tabs, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TabPanel = ({ children, value, index, keepMounted, ...other }) => (
  <Box
    aria-labelledby={`tabform-tab-${index}`}
    hidden={value !== index}
    id={`tabform-tabpanel-${index}`}
    role="tabpanel"
    {...other}
  >
    {(keepMounted || value === index) && (
      <Box sx={{ p: { xs: 2, sm: 2.5 } }}>{children}</Box>
    )}
  </Box>
);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  keepMounted: PropTypes.bool,
  value: PropTypes.any.isRequired,
};

TabPanel.defaultProps = {
  keepMounted: false,
};

const TabFormV2 = ({ tabPanels, currentTab, onChangeTab, keepMounted }) => {
  const [tab, setTab] = useState(currentTab);

  const handleChange = (event, newValue) => {
    onChangeTab(newValue);
    setTab(newValue);
  };

  useEffect(() => {
    if (Number.isInteger(currentTab) && currentTab !== tab) {
      setTab(currentTab);
    }
  }, [currentTab]);

  if (tabPanels.length === 1) {
    return <Box>{tabPanels[0].element}</Box>;
  }

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      <Tabs
        value={tab}
        onChange={handleChange}
        variant="standard"
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          px: 2,
          minHeight: 48,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            minHeight: 48,
            minWidth: 'auto',
            mr: 2,
            px: 0,
            color: 'text.secondary',
            '&.Mui-selected': {
              color: 'primary.main',
            },
          },
          '& .MuiTabs-indicator': {
            backgroundColor: 'primary.main',
            height: 2,
          },
        }}
      >
        {tabPanels.map((panel, index) => (
          <Tab
            key={panel.id || index}
            label={
              panel.infoTooltip ? (
                <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                  {panel.label}
                  <Tooltip title={panel.infoTooltip}>
                    <Box
                      component="span"
                      sx={{ display: 'inline-flex', pointerEvents: 'auto', lineHeight: 0 }}
                    >
                      <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                    </Box>
                  </Tooltip>
                </Box>
              ) : panel.label
            }
            id={`tabform-tab-${index}`}
            aria-controls={`tabform-tabpanel-${index}`}
            disabled={panel.disabled}
          />
        ))}
      </Tabs>

      {tabPanels.map((panel, index) => (
        <TabPanel
          key={panel.id || index}
          value={tab}
          index={index}
          keepMounted={keepMounted}
        >
          {panel.element}
        </TabPanel>
      ))}
    </Box>
  );
};

const tabPanelShape = PropTypes.shape({
  id: PropTypes.string,
  label: PropTypes.node.isRequired,
  element: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  infoTooltip: PropTypes.node,
});

TabFormV2.propTypes = {
  tabPanels: PropTypes.arrayOf(tabPanelShape).isRequired,
  currentTab: PropTypes.number,
  keepMounted: PropTypes.bool,
  onChangeTab: PropTypes.func,
};

TabFormV2.defaultProps = {
  currentTab: 0,
  keepMounted: false,
  onChangeTab: () => {},
};

export default TabFormV2;
